import ApiService from "../api";

/** Configurações gerais liga/desliga do módulo de Solicitações (aba "Configuração"). */
export default class ConfiguracaoSolicitacaoService extends ApiService {

    constructor() {
        super('/api/solicitacoes/config/geral')
    }

    /** Todas as chaves, com o valor em vigor (só ADMIN). */
    listar() {
        return this.get(``)
    }

    /** Uma chave — qualquer usuário logado. Ex.: `buscar("BLOQUEAR_DESPESA_COM_COMPRA_EM_RECEBIMENTO")`. */
    buscar(chave) {
        return this.get(`/${chave}`)
    }

    alterar(chave, ativo) {
        return this.put(`/${chave}`, { ativo })
    }
}
